import { AiAnalyticsSummaryPageType } from "@redotech/redo-model/conversion/ai-analytics-summary";
import * as z from "zod/v4";

export const getAiAnalyticsSummary = {
  name: "getAiAnalyticsSummary" as const,
  input: z.object({ pageType: AiAnalyticsSummaryPageType }),
  output: z.object({
    summary: z.string().nullable(),
    createdAt: z.date().nullable(),
  }),
};
